import { resetPasswordUrl, requestJson, NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE, gaiaKey } from './config'
import { getConstId, handleResponse } from './utils'
import { myAxios } from '../utils'
const resetPasswordSendUrl = `${resetPasswordUrl}/send` // 重设密码时请求短信
const submitPasswordSmsUrl = `${resetPasswordUrl}/sms` // 重设密码时输入短信验证码
const setPasswordUrl = `${resetPasswordUrl}/set` // 重设密码
const firstSetPasswordUrl = `${resetPasswordUrl}/first-set` // 首次注册后-设置密码

/*
* 重置密码-发送短信验证码
*  */
export const resetPasswordSend = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(resetPasswordSendUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res, [ NEED_CAPTCHA_CODE, NEED_SECOND_CAPTCHA_CODE ])
    })
}

/*
* 重置密码-提交短信验证码
*  */
export const submitResetPasswordSms = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(submitPasswordSmsUrl, paramsData, {
    loading: {
      message: '校验中'
    },
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 重置密码-设置密码
*  */
export const setPassword = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(setPasswordUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 首次登录后-设置密码
*  */
export const firstSetPassword = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(firstSetPasswordUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
